import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

// const $LANGUAGE = (navigator.language || navigator.browserLanguage).toLowerCase()
// console.log($LANGUAGE)
export default new Vuex.Store({
  state: {
    tab: '',
    language: Cookies.get('language') || 'en'
  },
  getters: {
    language: state => state.language
  },
  mutations: {
    changeTab (state, tab) {
      state.tab = tab
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    }
  },
  actions: {
    setLanguage ({ commit }, language) {
      commit('SET_LANGUAGE', language)
    }
  }
})
